import { logChannelRequestFailure } from 'setup/logger/logChannelRequestFailure';
import { logoutClient } from 'shared/domain/logout/logoutClient';

/**
 * Signs out in the worker, which tells every tab. Resolves once the worker
 * dropped the user's data, or after a failure (logged): signing out goes on.
 */
export async function requestServiceWorkerLogout(): Promise<void> {
  try {
    await logoutClient.logOut();
  } catch (error) {
    logChannelRequestFailure('Service worker logout failed', error);
  }
}
